export default __webpack_public_path__ + "3f06da39db825868f0ce4f7dfc9b2fbd.png";